export default __webpack_public_path__ + "static/media/no_addresses.5d88dcb3.svg";